<template>
    <el-upload
        ref="myUpload"
        action
        :show-file-list="false"
        :before-upload="beforeUpload"
        :on-success="afterUpload"
        :http-request="httpRequest">
        <el-button  type="primary" >{{ btnText }}</el-button>
    </el-upload>
</template>

<script>
// 限制文件大小
const FILE_SIZE = {
    TEN: 10,
    FIVE_HUNDRED: 500,
    ONE_THOUSAND_AND_TWENTY_FOUR: 1024
};

export default {
    props: {
        btnText: {
            type: String,
            default: '导出'
        },
        httpRequest: {
            type: Function,
            require: true
        }
    },
    methods: {
        triggerUpload() {
            this.$nextTick(() => {
                const uploadInput = this.$refs.myUpload.$el.querySelector('.el-upload__input');
                uploadInput.click();
            });
        },
        afterUpload(response) {
            if (response && response.code === '0') {
                this.$message.success('导入成功');
                this.load();
            }
        },
        beforeUpload(file) {
            var fileNameArr = file.name.split('.');
            var fileType = fileNameArr[fileNameArr.length - 1];

            const Excel = fileType === 'xls' || fileType === 'xlsx';
            const isLt500KB = file.size / 1024 <= FILE_SIZE.FIVE_HUNDRED;

            if (!Excel) {
                this.$message.error('上传失败，文件格式只能为 xlsx 或 xls');
            } else if (!isLt500KB) {
                this.$message.error('上传文件大小不能超过 500KB');
            }
            return Excel && isLt500KB;
        }
    }
};
</script>